
import Nuclias from "const/nuclias";
import dayjs from "dayjs";
import { isNil, size, cloneDeep } from 'lodash';

const { timeFormat, licenseConfig, deviceConfig } = Nuclias;

const setPeriodTimestamp = (lic) => {

  lic.isFree = size(lic.key) === licenseConfig.freeLength ? true : false;
  lic.licenseType = lic.deviceUid ? licenseConfig.usedTypes.used : licenseConfig.usedTypes.unused;
  lic.deviceTypeLabel = lic.deviceType === licenseConfig.deviceType.ap ? 'cb3f9a1103'
    : (lic.deviceType === licenseConfig.deviceType.switch ? 'bbc155fb2b' : '926dec9494');
  lic.licenseState = !isNil(lic.suspendedAt) ? licenseConfig.statusTypes.suspended
    : (!isNil(lic.startDate) ? licenseConfig.statusTypes.active : licenseConfig.statusTypes.inactive);

  const checkList = ['releasedAt', 'startDate', 'endDate', 'suspendedAt'];
  for (const item of checkList) {
    if (!isNil(lic[item])) {
      lic[`${item}Unix`] = dayjs(lic[item]).unix();
      lic[`${item}Format`] = dayjs(lic[item]).format(timeFormat.yDateAndTime);
    } else {
      lic[`${item}Unix`] = null;
    }
  }

  switch (lic.unit) {
    case licenseConfig.termUnit.year:
      lic.termUnitLabel = lic.period === 1 ? '537c66b24e' : 'e4a00407f4';
      lic.termDays = lic.period * 365;
      break;
    case licenseConfig.termUnit.month:
      lic.termUnitLabel = lic.period === 1 ? '7cbb885aa1' : 'ef831a7b02';
      lic.termDays = lic.period * 30;
      break;
    case licenseConfig.termUnit.day:
      lic.termUnitLabel = lic.period === 1 ? '03727ac485' : 'e807d3ccf8';
      lic.termDays = 1;
      break;
    default:
      console.debug(`lic undefined unit: ${lic}`);
  }
  return lic;
};

const getLicenseRemainDate = (lic) => {
  // Unix
  lic = setPeriodTimestamp(lic);

  lic.remainDayCount = null;
  lic.remainDayUnit = null;
  if (!isNil(lic.timeRemaining)) { // from API
    lic.remainDayCount = Math.floor(lic.timeRemaining / (60 * 60 * 24));
    lic.remainDayUnit = lic.remainDayCount > 1 ? '44fdec4703' : '628b7db042';
  } else {
    if (lic.state === licenseConfig.state.EXHAUSTED) {
      lic.remainDayCount = 0;
      lic.remainDayUnit = '628b7db042';
    } else {
      switch (lic.unit) {
        case licenseConfig.termUnit.year:
          lic.remainDayCount = lic.period * 365;
          lic.remainDayUnit = '44fdec4703';
          break;
        case licenseConfig.termUnit.month:
          lic.remainDayCount = lic.period * 30;
          lic.remainDayUnit = '44fdec4703';
          break;
        case licenseConfig.termUnit.day:
          lic.remainDayCount = lic.period * 1;
          lic.remainDayUnit = lic.remainDayCount > 1 ? '44fdec4703' : '628b7db042';
          break;
        default:
          console.debug(`lic undefined unit ${lic}`);
      }
    }
  }

  if (lic.state === licenseConfig.state.SUSPENDED || lic.state === licenseConfig.state.SUSPENDED_WAIT_FOR_RESUME) {
    lic.endDateFormat = null;
    lic.endDateUnix = null;
  }
  return lic;
};

const getDeviceLicenseRemainDate = (deviceState, lics) => {
  // return new Promise(async (Resolve, Reject) => {
  const remainLics = lics.map((lic) => {
    if (lic.state !== licenseConfig.state.EXHAUSTED) {
      return getLicenseRemainDate(cloneDeep(lic));
    }
  });

  const result = {
    firstStartDateFormat: '',
    firstStartDateUnix: 0,
    expirationDateFormat: '',
    expirationUnix: 0,
    totalRemainDay: '',
    inUsedList: [],
  };

  let tmpFirstLic = null;
  for (const lic of remainLics) {
    const daySec = 60 * 60 * 24;
    const licObj = {
      key: lic.key,
      second: daySec * lic.remainDayCount,
      startDate: lic.startDateFormat,
      startDateUnix: lic.startDateUnix,
      endDate: lic.endDateFormat,
      endDateUnix: lic.endDateUnix,
      state: lic.state,
      period: lic.period,
      remainDayCount: lic.remainDayCount,
      timeRemaining: lic.timeRemaining,
      unit: lic.unit,
    };
    if (deviceState === deviceConfig.licenseState.SUSPENDED && lic.state === licenseConfig.state.SUSPENDED) {
      tmpFirstLic = licObj;
    } else if (deviceState === deviceConfig.licenseState.ACTIVATED
      && lic.state !== licenseConfig.state.SUSPENDED_WAIT_FOR_RESUME && !isNil(lic.startDate)) {
      tmpFirstLic = licObj;
    } else {
      if (lic.state !== licenseConfig.state.EXHAUSTED) {
        result.inUsedList.push(licObj);
      }
    }
  }

  if (!isNil(tmpFirstLic)) {
    result.inUsedList.splice(0, 0, tmpFirstLic);
  }

  if (deviceState === deviceConfig.licenseState.ACTIVATED && size(result.inUsedList) > 0) {
    result.totalRemainDay = result.inUsedList[0].remainDayCount;
    result.firstStartDateUnix = result.inUsedList[0].startDateUnix;
    result.firstStartDateFormat = dayjs(result.inUsedList[0].startDateUnix * 1000).format(timeFormat.yDate);
    result.expirationUnix = result.inUsedList[0].endDateUnix;
    for (const [index, usedLic] of result.inUsedList.entries()) {
      if (index !== 0) {
        result.totalRemainDay += usedLic.remainDayCount;
        result.expirationUnix += usedLic.second;
      }
    }
    result.expirationDateFormat = dayjs(result.expirationUnix * 1000).format(timeFormat.yDate);
  }
  return result;
  // Resolve(result);
  // });
};

export default {
  getLicenseRemainDate,
  getDeviceLicenseRemainDate,
};